<div class="h-[90vh] max-w-[1400px] mx-auto flex items-center justify-center">
  <div class="w-[500px]">
    <div class="text-center text-8xl mb-4">403</div>
    <tui-notification status="error" size="l">
      Недостаточно прав для просмотра страницы
    </tui-notification>
  </div>
</div>
